const LOCAL_TEST_PLANS = new Set(["starter", "pro", "team", "lifetime", "vitalicio"]);

export function getLocalTestPlan() {
  if (typeof window === "undefined") return "";

  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (!isLocalhost) return "";

  const fromStorage = window.localStorage.getItem("qa_local_plan");
  const fromEnv = process.env.REACT_APP_LOCAL_TEST_PLAN;
  const candidate = String(fromStorage || fromEnv || "").toLowerCase();

  if (candidate === "team") return "pro";
  if (candidate === "vitalicio") return "lifetime";
  return LOCAL_TEST_PLANS.has(candidate) ? candidate : "";
}
